// extracted by mini-css-extract-plugin
module.exports = {"widget":"DashboardDataWidget_widget__GsgWh","sections":"DashboardDataWidget_sections__2pOBI","description":"DashboardDataWidget_description__21p_d"};